import { ConsultaEstadoComponent } from './libro-reclamaciones/consulta-estado/consulta-estado.component';
import { SolicitudesComponent } from './libro-reclamaciones/solicitudes/solicitudes.component';
// routing routingurls routing-urls
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LayoutComponent} from './layout/layout.component'
import { LoginComponent } from './login/login.component';
import { EvaluaFacturaComponent } from './evaluaFactura/evaluaFactura.component'
import { RecuperarPasswordComponent } from './recuperar-password/recuperar-password.component';
import { ValidateUserComponent } from './validate-user/validate-user.component';
import { SorteoComponent } from './sorteo/sorteo.component';
import { RespuestaNoPrecalificaComponent } from './evalua-factura-respuesta/respuesta-no-precalifica/respuesta-no-precalifica.component';
import { RespuestaPrecalificaComponent } from './evalua-factura-respuesta/respuesta-precalifica/respuesta-precalifica.component';
import { ResumenFinalComponent } from './evalua-factura-respuesta/resumen-final/resumen-final.component';
//todos los componentes internos iran en  layout.routing.ts a.k.a routing-interno
 // import { PromoComponent } from './promo/promo.component';
// import { DashboardComponent} from './dashboard/dashboard.component'


const routes: Routes =[
  //Set Pagina de inicio
  { path: '', component: LoginComponent},
  //set de URLs
  { path: 'login', component: LoginComponent },
  { path: 'recovery', component: RecuperarPasswordComponent },
  { path: 'registrar', component: SorteoComponent },
  { path: 'evalua-tu-factura', component: EvaluaFacturaComponent},
  { path: 'evalua-tu-factura/:tipoDoc/:numDoc/:nombre/:celular/:correo/:rucProv/:rucAdq', component: EvaluaFacturaComponent},
  { path: 'respuesta-precalifica/:rucAdq', component: RespuestaPrecalificaComponent },
  { path: 'respuesta-no-precalifica/:rucAdq', component: RespuestaNoPrecalificaComponent },
  { path: 'resumen-final', component: ResumenFinalComponent },
  { path: 'validate/:user/:token', component: ValidateUserComponent },
  { path: 'auth/validar-usuario/:user/:token', component: ValidateUserComponent },
  { path: 'libro-reclamaciones', component: SolicitudesComponent },
  { path: 'consulta-estado', component: ConsultaEstadoComponent },
  {
    path: '',
    component: LayoutComponent,
    children: [{
      path: '',
      loadChildren: './layout/layout.module#LayoutModule'
    }]
  },
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
